<template>
	<div class="first_article" :style="{
		borderBottom: border?'0.0625rem solid rgba(228, 65, 0, 0.3)':''
	}">
		<div @click="goDetail" class="first_title line-1">{{ text.title || '-'}}</div>
		<div class="first_sub line-2" v-html="text.subTitle" v-if="hasSub"></div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				text: {
					title: '',
					id:'',
					subTitle: ''
				}
			}
		},
		methods:{
			goDetail(id,flag){
	
			
				this.$emit("goDetail",this.textInfo.id,1)
			}
		},
		props:{
			textInfo: {
				type: Object,
				default: () => {
					return {
						title: '',
						id:'',
						subTitle: ''
					}
				}
			},
			border:{
				type:Boolean,
				default:true
			},
			hasSub:{
				type:Boolean,
				default:true
			}
		},
		watch: {
			textInfo: {
				handler(val) {
					this.text = {}
					if(val){
						this.text = val;
					}
				},
				deep: true,
				immediate: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.first_article{
		width: 100%;
		padding-bottom: 0.625rem;
		cursor: pointer;
		.first_title{
			width: 100%;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			font-size: 1.5rem;
			font-weight: bold;
		}
		.first_sub{
			margin-top: 0.3125rem;
			color: #666;
			font-size: 1.125rem;
			line-height: 1.875rem;
		}
		
		&:hover{
			opacity: .8;
		}
	}
</style>